import store from "@/store/index.js";
export default {
  name: "Menu",
  components: {},
  data() {
    return {
      menuList: [
        {
          name: "Lista przebojów programu 3",
          link: "/",
        },
        {
          name: "top wszech czasów",
          link: "/topwszechczasow",
        },
        {
          name: "polski top wszech czasów",
          link: "/polskitopwszechczasow",
        },
        // {
        //   name: "zespół",
        //   link: "/zespol"
        // },
        {
          name: "multimedia",
          link: "/multimedia",
        },
        {
          name: "kontakt",
          link: "https://trojka.polskieradio.pl/kontakt",
        },
      ],
    };
  },
  methods: {
    goToSites(adress) {
      if (adress.includes("https://")) {
        window.location.href = adress
      }
      store.dispatch("selectNote", null);

      this.$router.push(`${adress}`);
    },
    isActive(adress) {
      let link = this.$route.path;
      if (link === adress) {
        return true;
      }
    },
  },
  mounted() {},
};
